module.exports = __webpack_public_path__ + "img/modeling.e376e4c6.svg";